export const types = {
  RESET_USER:'RESET_USER',
  MAKE_LOGIN_BEGINS: 'USERS/MAKE_LOGIN_BEGINS',
  MAKE_LOGIN_SUCCESS: 'USERS/MAKE_LOGIN_SUCCESS',
  MAKE_LOGIN_FAILURE: 'USERS/MAKE_LOGIN_FAILURE',
  RESET_MAKE_LOGIN: 'USERS/RESET_MAKE_LOGIN',
  SET_USER_TOKEN: 'USERS/SET_USER_TOKEN',
  SET_USER_ROL: 'USERS/SET_USER_ROL',

  MAKE_LOGOUT_BEGINS: 'USERS/MAKE_LOGOUT_BEGINS',
  MAKE_LOGOUT_SUCCESS: 'USERS/MAKE_LOGOUT_SUCCESS',
  MAKE_LOGOUT_FAILURE: 'USERS/MAKE_LOGOUT_FAILURE',
  RESET_MAKE_LOGOUT: 'USERS/RESET_MAKE_LOGOUT',

  GET_AUTHENTICATED_BEGINS: 'USERS/GET_AUTHENTICATED_BEGINS',
  GET_AUTHENTICATED_SUCCESS: 'USERS/GET_AUTHENTICATED_SUCCESS',
  GET_AUTHENTICATED_FAILURE: 'USERS/GET_AUTHENTICATED_FAILURE',

  CHANGE_PASSWORD_BEGINS: 'USERS/CHANGE_PASSWORD_BEGINS',
  CHANGE_PASSWORD_SUCCESS: 'USERS/CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE: 'USERS/CHANGE_PASSWORD_FAILURE',
  RESET_CHANGE_PASSWORD: 'USERS/RESET_CHANGE_PASSWORD',

}

export const initialState = {
  makeLoginStatus: null,
  makeLoginStatusFetching: false,
  makeLoginStatusError: null,
  userToken: null,
  menu: null,
  userRol: null,

  makeLogoutStatus: null,
  makeLogoutDone: false,
  makeLogoutStatusData: null,
  makeLogoutStatusFetching: false,
  makeLogoutStatusError: null,

  authenticated: null,
  authenticatedFetching: false,
  authenticatedError: null,

  changePasswordStatus: null,
  changePasswordFetching: false,
  changePasswordError: null,

}

const UsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_USER: {
      localStorage.removeItem('token');
      localStorage.removeItem('currentUserRol');
      return {
        ...initialState,
        makeLogoutDone: true,
      }
    }
    case types.MAKE_LOGIN_BEGINS: {
      return {
        ...state,
        makeLoginStatusFetching: true,
        makeLoginStatusError: null,
      }
    }
      case types.MAKE_LOGIN_SUCCESS: {
      const data = action.payload;
      let userRol = null;
      let userToken = null;
      let menu = null;
      if (data && data.data) {
          userRol = data.data.rol;
          localStorage.setItem('currentUserRol', userRol)

          userToken = data.data.token;
          localStorage.setItem('token', userToken)

          menu = data.data.menu
      }
      return {
        ...state,
        makeLoginStatus: data.status,
        makeLoginStatusFetching: false,
        makeLoginStatusError: null,
        userToken,
        userRol,
        menu: menu
      }
    }
      case types.MAKE_LOGIN_FAILURE:
      return { 
        ...state,
        makeLoginStatusFetching: false,
        makeLoginStatusError: action.payload,
      }
    case types.RESET_MAKE_LOGIN: {
      return { 
        ...state,
        makeLoginStatus: null,
        makeLogoutDone: false,
        makeLoginStatusFetching: false,
        makeLoginStatusError: null,
      }
    }
    case types.SET_USER_TOKEN: {
      return {
        ...state,
        userToken: action.payload,
      }
    }
    case types.SET_USER_ROL: {
      return {
        ...state,
        userRol: action.payload,
      }
    }
    case types.MAKE_LOGOUT_BEGINS: {
      return {
        ...state,
        makeLogoutStatusFetching: true,
        makeLogoutStatusError: null,
      }
    }
    case types.MAKE_LOGOUT_SUCCESS: {
      const data = action.payload;
      localStorage.removeItem('token');
      localStorage.removeItem('currentUserRol');
      return {
        ...state,
        makeLogoutStatus: data.status,
        makeLogoutStatusData: data.data,
        makeLogoutStatusFetching: false,
        makeLogoutStatusError: null,
        userToken: null,
        userRol: null,
        authenticated: null,
        authenticatedFetching: false,
        authenticatedError: null,
        makeLoginStatus: null,
        makeLoginStatusFetching: false,
        makeLoginStatusError: null,
        menu: null,
        makeLogoutDone: true,
      }
    }
    case types.MAKE_LOGOUT_FAILURE:
      return { 
        ...state,
        makeLogoutStatusFetching: false,
        makeLogoutStatusError: action.payload,
      }
    case types.RESET_MAKE_LOGOUT:
      return { 
        ...state,
        makeLogoutStatus: null,
        makeLogoutStatusData: null,
        makeLogoutStatusFetching: false,
        makeLogoutStatusError: null,
      }
    case types.GET_AUTHENTICATED_BEGINS: {
      return {
        ...state,
        authenticatedFetching: true,
        authenticatedError: null,
      }
    }
    case types.GET_AUTHENTICATED_SUCCESS: {
      const data = action.payload;
      let menu = null;
      let authenticated = null;
      if (data && data.data) {
          ({ menu } = data.data);
          authenticated = data.data.usuario;
      }
      return {
        ...state,
        authenticated,
        authenticatedFetching: false,
        authenticatedError: null,
        statusCode : data.status,
        menu: menu
      }
    }
    case types.GET_AUTHENTICATED_FAILURE:
      return { 
        ...state,
        authenticatedFetching: false,
        authenticatedError: action.payload,
      }
    case types.CHANGE_PASSWORD_BEGINS: {
      return {
        ...state,
        changePasswordStatus: null,
        changePasswordFetching: true,
        changePasswordError: null,
      }
    }
    case types.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        changePasswordStatus: action.payload?.data,
        changePasswordFetching: false,
        changePasswordError: null,
      }
    }
    case types.CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        changePasswordFetching: false,
        changePasswordError: action.payload,
      }
    case types.RESET_CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordStatus: null,
        changePasswordFetching: false,
        changePasswordError: null,
      }
  default:
    return state
  }
}

export const actions = {

  resetUser: () => ({ type: types.RESET_USER }),
  makeLogin: (userOrEmail, pass) => ({ type: types.MAKE_LOGIN_BEGINS, payload: { userOrEmail, pass } }),
  successMakeLogin: data => ({ type: types.MAKE_LOGIN_SUCCESS, payload: data, }),
  errorMakeLogin: error => ({ type: types.MAKE_LOGIN_FAILURE, payload: error, }),
  resetMakeLogin: () => ({ type: types.RESET_MAKE_LOGIN }),
  setUserToken: data => ({ type: types.SET_USER_TOKEN, payload: data}),
  setUserRol: data => ({ type: types.SET_USER_ROL, payload: data}),


  makeLogout: () => ({ type: types.MAKE_LOGOUT_BEGINS }),
  successMakeLogout: data => ({ type: types.MAKE_LOGOUT_SUCCESS, payload: data, }),
  errorMakeLogout: error => ({ type: types.MAKE_LOGOUT_FAILURE, payload: error, }),
  resetMakeLogout: () => ({ type: types.RESET_MAKE_LOGOUT }),

  getAuthenticated: () => ({ type: types.GET_AUTHENTICATED_BEGINS }),
  successGetAuthenticated: data => ({ type: types.GET_AUTHENTICATED_SUCCESS, payload: data, }),
  errorGetAuthenticated: error => ({ type: types.GET_AUTHENTICATED_FAILURE, payload: error, }),
  changePassword: (currentPassword, newPassword, confirmPassword) => ({ type: types.CHANGE_PASSWORD_BEGINS, payload: { currentPassword, newPassword, confirmPassword } }),
  successChangePassword: data => ({ type: types.CHANGE_PASSWORD_SUCCESS, payload: data, }),
  errorChangePassword: error => ({ type: types.CHANGE_PASSWORD_FAILURE, payload: error, }),
  resetChangePassword: () => ({ type: types.RESET_CHANGE_PASSWORD }),
  
}

export default UsersReducer;